import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { rem } from 'polished'
import styled from 'styled-components'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import ContactContext from 'contexts/contactContext'
import getIsLoyaltyPrioritySupportNumberEnabled from 'loyalty/selectors/getIsLoyaltyPrioritySupportNumberEnabled'
import { useAppSelector } from 'hooks/reduxHooks'

/** Copy + (on mobile) the call chip, with the design's 12px gap between them. */
const SupportContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};
`

interface Props {
  layout: 'tile' | 'row'
}

function LandingPageLoyaltyPhoneSupport(props: Props) {
  const { layout } = props
  const contact = useContext(ContactContext)
  const isLoyaltyPrioritySupportNumberEnabled = useAppSelector(getIsLoyaltyPrioritySupportNumberEnabled)
  const intl = useIntl()

  const callButton = useMemo(() => {
    if (!isLoyaltyPrioritySupportNumberEnabled) return
    return <TextButton kind="secondary" variant="default" size="small" shape="round" href={`tel:${contact.local.number}`} startIcon={<LinePhoneIcon />}>
      {contact.local.humanReadable}
    </TextButton>
  }, [isLoyaltyPrioritySupportNumberEnabled, contact.local.number, contact.local.humanReadable])

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="phone_support"
    heading={intl.formatMessage({
      defaultMessage: 'Priority phone support 24/7',
      id: 'noRXviusEAZtYRSSP6v4',
      description: 'Heading for loyalty priority phone support benefit tile',
    })}
    subtitle={<SupportContent>
      <BodyText variant="small">{intl.formatMessage({
        defaultMessage: 'Dedicated travel specialists available whenever you need help',
        id: 'uQXEV3unRSfFt_JYbqfV',
        description: 'Subtitle for loyalty priority phone support benefit tile',
      })}
      </BodyText>
      {callButton && <CSSBreakpoint max="mobile">{callButton}</CSSBreakpoint>}
    </SupportContent>}
    trailing={callButton && <CSSBreakpoint min="tablet">{callButton}</CSSBreakpoint>}
  />
}

export default LandingPageLoyaltyPhoneSupport
